// Angular
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
// Module
import { CvLayoutRenderModule } from './cv-layout-render/cv-layout-render.module';
import { OpenSchemaDirectivesModule } from './directives/open-schema-directives.module';

@NgModule({
	imports: [
		CommonModule,
		CvLayoutRenderModule,
		OpenSchemaDirectivesModule
	],
	exports: [
		CvLayoutRenderModule,
		OpenSchemaDirectivesModule
	]
})
export class OpenSchemaModule {
}
